import { Controller } from "@hotwired/stimulus"

// A <select> whose option values are URLs: changing it navigates the list to
// that URL without a full reload. Loads into the closest turbo-frame (or the
// one named by the `frame` value, default "content") and advances history so
// the address bar and the selected option stay in sync. Mirrors the
// frame-driving technique in per-page-select.
export default class extends Controller {
  static values = { frame: { type: String, default: "content" } }

  change(event) {
    const url = event.target.value
    if (!url) return

    const frame = this.element.closest("turbo-frame") || document.getElementById(this.frameValue)
    if (!frame) {
      window.location.assign(url)
      return
    }

    const link = document.createElement("a")
    link.href = url
    link.setAttribute("data-turbo-frame", frame.id)
    link.setAttribute("data-turbo-action", "advance")
    link.hidden = true
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}
